import { isKenwood } from '@/utils/Common/Booleans';

const getfieldToChangeLabel = () => {
  try {
    return document.querySelectorAll('.ownId-left label');
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error getting labels', error);
    return [];
  }
};

// eslint-disable-next-line import/prefer-default-export
export const setLabelMargin = () => {
  if (window.ownid && typeof window.ownid === 'function') {
    const labelToMoveArray = getfieldToChangeLabel();
    labelToMoveArray.forEach(label => {
      const inputId = label.getAttribute('for');
      const inputField = document.getElementById(inputId);

      if (inputField && !isKenwood) {
        let intervalId;
        let timeElapsed = 0;

        const checkAndApplyMargin = () => {
          const currentMarginLeft = parseFloat(
            window.getComputedStyle(inputField).marginLeft,
          );

          if (currentMarginLeft > 0) {
            label.style.left = `calc(${currentMarginLeft}px + 8px)`;
            clearInterval(intervalId);
          }

          timeElapsed += 100;
          if (timeElapsed >= 30000) {
            clearInterval(intervalId);
          }
        };

        intervalId = setInterval(checkAndApplyMargin, 100);
      }
    });
  }
};
